import getHumanReadableDateFromMillisecondTimestamp from '@th/shared/src/utils/getHumanReadableDateFromMillisecondTimestamp';

export default function getDateFromBlock(block: any): string {
  return getHumanReadableDateFromMillisecondTimestamp(block.value.created_time);
}
